module.exports = __webpack_public_path__ + "img/info-01.0aa8d4e4.jpg";